module.exports = __webpack_public_path__ + "img/sdc2018_1.c94ffe25.png";